var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMhoDownArrowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "9px",
    viewBox: "0 0 16 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help",
    transform: "translate(-408.000000, -769.000000)",
    fill: "#023860",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.334735,769.329505 C408.776447,768.894694 409.489775,768.890212 409.937088,769.316057 L409.950979,769.329505 L416,775.284016 L422.049021,769.329505 C422.490733,768.894694 423.204061,768.890212 423.651374,769.316057 L423.665265,769.329505 C424.106977,769.764315 424.111531,770.466497 423.678926,770.906821 L423.665265,770.920495 L416.808122,777.670495 C416.36641,778.105306 415.653082,778.109788 415.205769,777.683943 L415.191878,777.670495 L408.334735,770.920495 C407.888422,770.481155 407.888422,769.768845 408.334735,769.329505 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMhoDownArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mho-down-arrow-icon.796a6ad9b8a3befbe34b933aa14d9893.svg";